var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { users } from '../services/api/saas';
const unescapeHtml = (escapedStr) => {
    const div = document.createElement('div');
    div.innerHTML = escapedStr;
    const child = div.childNodes[0];
    return child ? child.nodeValue : null;
};
const validateProtocol = (url) => {
    const parser = document.createElement('a');
    parser.href = url;
    const protocol = parser.protocol.toLowerCase();
    if (
    // eslint-disable-next-line no-script-url
    ['javascript:', 'vbscript:', 'data:', 'ftp:', ':', ' '].indexOf(protocol) < 0) {
        return url;
    }
    return null;
};
const validate = (url) => {
    const unescapedValue = unescapeHtml(url);
    if (unescapedValue && validateProtocol(unescapedValue)) {
        return unescapedValue;
    }
    return '/';
};
export default ({ desktopAppInstalledOrNot, deeplink, newUser, }) => {
    useEffect(() => {
        const doEffect = () => __awaiter(void 0, void 0, void 0, function* () {
            let hasURI = false;
            let intervalExecuted = false;
            const iframe = document.getElementById('desktop-app-checker');
            const link = yield users.getCustomTokenURL(newUser);
            iframe.src = validate(deeplink || link);
            window.setTimeout(() => {
                if (!hasURI) {
                    desktopAppInstalledOrNot(false);
                }
                else {
                    desktopAppInstalledOrNot(true);
                }
                intervalExecuted = true;
            }, 300);
            // eslint-disable-next-line
            let reset;
            const onBlur = () => {
                hasURI = true;
            };
            const onFocus = () => {
                reset();
                if (!hasURI && intervalExecuted) {
                    desktopAppInstalledOrNot(false);
                }
                else if (hasURI) {
                    desktopAppInstalledOrNot(true);
                }
            };
            reset = () => {
                window.removeEventListener('focus', onFocus);
                window.removeEventListener('blur', onBlur);
            };
            window.addEventListener('focus', onFocus);
            window.addEventListener('blur', onBlur);
        });
        doEffect();
    }, []);
    return (React.createElement("div", null,
        React.createElement("iframe", { id: "desktop-app-checker", title: "desktop-app-checker", width: "1", height: "1", style: { visibility: 'hidden' } })));
};
